/**
 * @file store入口文件
 */
import Vue from 'vue';
import Vuex from 'vuex';
import escape from './modules/escape';
import kingRoad from './modules/kingRoad';
import pano from './modules/pano';
import note from './modules/note';
import welfare from './modules/welfare';
import {compareSv, getParamsFromUrl} from '@baidu/map-fe-utils';
import Const from '@/pages/pano-game/constant/Constant';
import server from '@/pages/pano-game/service';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

const state = {
    /** 基础数据* */
    // 判断端内外
    isNative: Const.devTap.isNative,
    // 判断版本
    isV3: false,
    urlParams: {},
    safeBarHeight: 40,
    isOver15100: false,
    /** 主页数据* */
    // 主页基础数据
    mainData: {},
    // 端外首页的h5地址
    mainUrl: Const.devTap.mainUrl,
    // 端外首页的二维码地址
    erCode: Const.devTap.erCode,
    // 首页模式入口，v3
    modeTabs: [],
    // 大逃杀在线人数
    playingNum: 0,
    // 活动规则
    rules: [],
    // 主页全景是否加载完成
    isMainPanoReady: false,
    // 接口判断当前用户类型，默认是老手
    newPeople: false,
    // 主页全景 PID
    mainPid: '',
    // 2 无中断  1 有中断
    isContinue: Const.continue.no,
    // 中断类型
    continueType: '',
    // 加密 budss
    shareCode: '',
    // 玩了几局次数,
    inning: 0,
    // 免费次数
    gameNum: 3,
    // 此模式下通关需要答题数
    topicNum: Const.defaultTopicNum,
    // 大逃杀默认关数
    escapeTopicNum: Const.defaultEscapeTopicNum,
    // 免费复活已经使用次数
    freeNum: 0,
    // 免费复活总次数
    freeNumT: 0,
    // 免费助力已经使用次数
    assistNum: 0,
    // 免费助力总次数
    assistNumT: 0,
    // 大师模式消耗金币
    masterCoin: 100,
    // 普通模式消耗金币
    ordinaryCoin: 200,
    // 游戏类型
    gameMode: '',
    // 判断是否新人模式
    isNewPeopleMode: false,
    // 判断是否大逃杀模式
    isEscape: false,
    // 判断是否闯关模式
    isKingRoad: false,
    // 大逃杀参与人头像数组,仅显示3个
    avatarList: [],
    // 保留其余头像
    baseAvatarList: [],
    // 好友助力的开始时间戳
    startTime: 0,
    // 当前时间
    now: 0,
    // 金币复活
    resurrec: 0,
    isNotice: 0,
    // 判断商城类型
    isMedal: false,
    currentScenePid: '',
    isShowHeader: true,
    panoLocation: {
        panoX: '',
        panoY: ''
    },
    // 助力情况
    helpStatus: 1,
    initHeading: 0,
    initPitch: 0,
    isLogin: 0,
    myCoin: 0,
    myCoinStatus: 0,
    // 活动状态
    activityStatus: 0,
    kling: [],
    staticImgData: null,
    cash: '',
    eventKey: '',
    // 普通模式加多少金币
    simple: 100
};
const mutations = {
    /** ******** 公共部分 *********** */
    // 公共部分
    setUrlParams(state, data) {
        state.urlParams = data || {};
        // 判断游戏及商城类型
        if (state.urlParams.type) {
            state.gameMode = state.urlParams.type;
            state.isNewPeopleMode = state.gameMode === Const.gameMode.newPeople;
            state.isEscape = state.gameMode === Const.gameMode.escape;
            state.isKingRoad = state.gameMode === Const.gameMode.kingRoad;
        }
        if (state.urlParams.welfare) {
            state.isMedal = state.urlParams.welfare === Const.welfareType.medal;
        }
        const stbarHeight = Number(data.stbar_height);
        const sv = data.sv || window.yymap.nativeAppAdapter.phoneinfo.sv || '';
        state.isV3 = data.abtest === Const.abtest.isV3;
        if (stbarHeight) {
            state.safeBarHeight = parseInt(stbarHeight, 10);
        }
        if (sv && compareSv(sv, '15.10.0') > -1) {
            state.isOver15100 = true;
        }
    },
    // 设置金币数
    setMyCoin(state, data) {
        state.myCoin = data;
    },
    setMyCoinStatus(state, data) {
        state.myCoinStatus = data;
    },
    // 登录信息设置
    setIsLogin(state, data) {
        state.isLogin = data;
    },
    /** ******** 主页部分 *********** */
    // 设置主页全景状态，是否加载完成
    setIsMainPanoReady(state, data) {
        state.isMainPanoReady = data;
    },
    setMainPid(state, data) {
        state.mainPid = data;
    },
    setIsContinue(state, data) {
        state.isContinue = data.isContinue;
        state.continueType = data.continuetype;
    },
    /** ******** 全景答题页部分 *********** */
    // 设置当前 pid
    setCurrentScenePid(state, data) {
        state.currentScenePid = data;
    },
    // 设置Heading
    setHeading(state, data) {
        state.initHeading = data;
    },
    // 设置Pitch
    setPitch(state, data) {
        state.initPitch = data;
    },
    // 设置助力情况
    setHelpStatus(state, data) {
        state.helpStatus = data;
    },
    // 设置邀请好友等待的时间
    setStartTime(state, data) {
        state.startTime = data;
    },
    // 设置主页接口的状态
    setMainStatus(state, data) {
        state.mainData = Object.assign(state.mainData, data);
        // 大逃杀在线人数
        state.playingNum = data.playingNum;
        state.escapeTopicNum = data.escapeTopicNum || Const.escapeTopicNum;
        localStorage.setItem('escape-playing-num', state.playingNum);

        // 自己的 ID
        state.shareCode = data.shareCode;
        // 活动规则
        state.rules = data.rules;
        // todo 暂未使用，页面会报错，先删掉，金币状态
        // if (data.myCoin > state.myCoin && state.myCoin !== 0) {
        //     state.myCoinStatus = 1;
        //     setTimeout(() => {
        //         if (state && state.myCoinStatus) {
        //             state.myCoinStatus = 0;
        //         }
        //     }, 2000);
        // }
        // 金币数目
        state.myCoin = data.myCoin;
        // 免费次数
        state.gameNum = data.gameNum;
        // 玩了几局免费的次数  （inning/gameNum）
        state.inning = data.inning;
        state.freeNum = data.freeNum;
        state.freeNumT = data.freeNumT;
        state.assistNum = data.assistNum;
        state.assistNumT = data.assistNumT;
        // 默认关数
        state.topicNum = data.topicNum || Const.defaultTopicNum;
        state.masterCoin = data.masterCoin;
        state.ordinaryCoin = data.ordinaryCoin;
        // 游戏类型
        state.gameMode = data.type || state.gameMode;
        state.isNotice = data.notice;
        state.activityStatus = data.activityStatus;
        state.kling = data.kling;
        state.initHeading = data.heading;
        state.initPitch = data.pitch;
        state.now = Number(data.currentTime) * 1000;
        state.resurrec = data.resurrec;
        state.cash = data.cash;
        state.eventKey = data.eventKey;
        state.isLottery = data.isLottery;

        // 设置端外分享二维码及地址
        if (data.customData && data.customData.shareConf && data.customData.shareConf.length) {
            const random = Math.floor(Math.random() * data.customData.shareConf.length);
            const shareConf = data.customData.shareConf[random || 0];
            state.mainUrl = shareConf.mainUrl;
            state.erCode = shareConf.erCode;
        }
        // 设置随机头像（v2）
        if (data.headPortrait && data.headPortrait.length) {
            state.avatarList = [];
            state.baseAvatarList = data.headPortrait;
            while (state.avatarList.length < 3) {
                const randomNum = Math.floor(Math.random() * state.baseAvatarList.length);
                state.avatarList.push(state.baseAvatarList.splice(randomNum, 1)[0]);
            }
        }

        // 设置首页各模式入口
        if (data.modeTabs && data.modeTabs.length) {
            state.modeTabs = data.modeTabs;
        }
        // 1是新手  2是老手
        state.newPeople = Number(data.newPeople) === 1;
        state.simple = data.simple;
        if (data.assistTime) {
            state.startTime = Number(data.assistTime) * 1000;
        }
        else {
            state.startTime = '';
        }
    },
    // 项目图片资源
    setStaticImg(state, data) {
        state.staticImgData = data;
    },
    setPlayingNum(state) {
        const randomNum = Math.floor(Math.random() * 20) * (state.playingNum % 2 ? 1 : -1);
        state.playingNum += randomNum;
    },
    // 设置随机头像
    setAvatarList(state) {
        if (state.baseAvatarList && state.baseAvatarList.length) {
            const randomNum = Math.floor(Math.random() * state.baseAvatarList.length);
            state.avatarList.push(state.baseAvatarList.splice(randomNum, 1)[0]);
            const old = state.avatarList.splice(0, 1)[0];
            state.baseAvatarList.push(old);
        }
    }
};
const getters = {
};
const actions = {
    // 公共部分
    getUrlParams: ({commit}) => {
        commit('setUrlParams', getParamsFromUrl());
    },
    // 主页部分
    getMainData: ({commit}, param) => {
        return server('main', param).then(res => {
            const mainData = res.data;
            if (res && res.errno === 0) {
                // 开发阶段使用模拟登录
                commit('setIsLogin', Const.devTap.mockLogin || mainData.isLogin);
                commit('setMainPid', mainData.backPid);
                commit('setIsContinue', mainData);
                commit('setMainStatus', mainData);
                commit('setStaticImg', mainData.customData);
                return res;
            }
            throw new Error(res.errstr);
        });
    },
    // 复活状态
    getHelpStatus: ({commit}, param) => {
        return server('help', param)
            .then(res => {
                commit('setHelpStatus', res.errno);
            });
    }

};

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    strict: debug,
    plugin: [],
    modules: {
        // 大逃杀主页数据
        escape,
        // 闯关主页数据
        kingRoad,
        // 答题页
        pano,
        // 错题本
        note,
        // 商城
        welfare
    }
});
